// extracted by mini-css-extract-plugin
module.exports = {"LabelPrimary":"LabelTitleParallel_LabelPrimary__shLRU","LabelSecondary":"LabelTitleParallel_LabelSecondary__27kRZ","LabelTertiary":"LabelTitleParallel_LabelTertiary__9P-k3"};